export const apiKeyKeys = {
    keys: (id) => ['api-keys', id],
};
